module.exports = __webpack_public_path__ + "img/2018-07-23 00.28.19 (1).d97b656e.jpg";